import { render, staticRenderFns } from "./franchise.vue?vue&type=template&id=2db70c21&scoped=true&"
import script from "./franchise.vue?vue&type=script&lang=js&"
export * from "./franchise.vue?vue&type=script&lang=js&"
import style0 from "./franchise.vue?vue&type=style&index=0&id=2db70c21&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db70c21",
  null
  
)

export default component.exports